// Map registrar_type → primary domain, used to fetch the registrar's favicon
// via Google's S2 service (no auth required, returns the site's own icon).
// Anything not listed renders without a logo.
export const REGISTRAR_LOGO_DOMAIN: Record<string, string> = {
  godaddy: 'godaddy.com',
  namecheap: 'namecheap.com',
  dynadot: 'dynadot.com',
  gandi: 'gandi.net',
  dreamhost: 'dreamhost.com',
  sedo: 'sedo.com',
  networksolutions: 'networksolutions.com',
  porkbun: 'porkbun.com',
  namesilo: 'namesilo.com',
  sav: 'sav.com',
  namebright: 'namebright.com',
  ilkari: 'ilkari.tech',
  whc: 'whc.ca',
  safenames: 'safenames.net',
  domainconz: 'domain.co.nz',
};

export function logoUrlFor(registrarType: string | null | undefined, size: 32 | 64 = 64): string | null {
  if (!registrarType) return null;
  const domain = REGISTRAR_LOGO_DOMAIN[registrarType];
  if (!domain) return null;
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`;
}
